import React from 'react'
import { Controller, FieldError } from 'react-hook-form'
import { Error } from '../styles'
import { Container, Field, Label } from './styles'

export interface InputProps {
  control: any
  label?: string
  error?: FieldError
  type?: 'radio' | 'checkbox'
  name: string
}

const CheckboxInput: React.FunctionComponent<InputProps> = ({
  control,
  type = 'radio',
  label,
  error,
  name,
}) => (
  <Controller
    key={name}
    name={name}
    control={control}
    render={({ field: { onChange, onBlur, value } }) => {
      const handleOnChange = (val: boolean) => {
        onChange(val)
      }

      return (
        <>
          <Container type={type}>
            <Field
              type={type}
              id={name}
              checked={value || false}
              error={!!error}
              onChange={(e) => handleOnChange(e.target.checked)}
              onBlur={onBlur}
            />
            {label && <Label>{label}</Label>}
          </Container>
          {error && <Error>{error.message}</Error>}
        </>
      )
    }}
  />
)

export default CheckboxInput
